import React from "react"
const useDisplayFormattedText = () => {
  const DisplayFormattedText = (text = "", number = 15, textOnly = false) => {
    if (text) {
      if (text.length < number) {
        return text;
      } else {
        if (textOnly) {
          return `${text.substring(0, number)}...`;
        }
        return <span title={text}>{`${text.substring(0, number)} ...`}</span>;
      }
    } else {
      return "";
    }
  };
  return { DisplayFormattedText };
};

export default useDisplayFormattedText;
